import React from 'react';

import { DateTime } from 'luxon';

import { Text } from '@clutter/clean';

import { Currency } from '@shared/components/helpers';

import { Section } from '@portal/components/orders/steps/confirm/section';
import { useTermCommitmentBalanceQuery } from '@portal/schema';

export const TermCommitmentBalance: React.FC<{
  scheduled: DateTime;
}> = ({ scheduled }) => {
  const { data } = useTermCommitmentBalanceQuery({ variables: { scheduled: scheduled.toJSON() } });
  const amountDue = data?.termCommitmentBalance?.amountDue || 0;

  return (
    <Section title="Term Commitment Balance">
      <Text.Body>
        The <Currency value={amountDue} /> balance left on your term commitment will be charged when you book this
        appointment. The appointment will not be booked if that charge fails.
      </Text.Body>
    </Section>
  );
};
